import {DirectiveOptions} from 'vue';
import Sortable from 'sortablejs';
import {DirectiveBinding} from 'vue/types/options';

const sortable: DirectiveOptions = {
    inserted: (el: HTMLElement, binding: DirectiveBinding): void => {
        // tslint:disable-next-line:no-unused-expression
        new Sortable(el, Object.assign(binding.value));
    }
};

export default sortable;
